import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IntegrationsMainComponent } from './containers/integrations-main/integrations-main.component';

const routes: Routes = [
  { path: '', component: IntegrationsMainComponent }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IntegrationsRoutingModule { }
